export default __webpack_public_path__ + "static/media/Group.d223ded8.svg";